// responseMessage.js

const responseMessage = {
    iconsStructure() {
        return {
            danger: {
                errorIcon: `${window.location.origin}/images/icons/alerts/error_icon_size_24.png`,
                trashIcon: `${window.location.origin}/images/icons/alerts/trash_icon_size_24.png`,
                title: "Error",
            },
            success: {
                errorIcon: `${window.location.origin}/images/icons/alerts/check_circle_icon_size_24.png`,
                trashIcon: `${window.location.origin}/images/icons/alerts/trash_icon_size_24.png`,
                title: "Success",
            },
            warning: {
                errorIcon: `${window.location.origin}/images/icons/alerts/warning_icon_size_24.png`,
                trashIcon: `${window.location.origin}/images/icons/alerts/trash_icon_size_24.png`,
                title: "Warning",
            },
        };
    },

    messageStructure(message, classname) {
        const icons = this.iconsStructure();
        const typeIcons = icons[classname] || icons.danger;

        return `
            <li class="list-group item">
                <div class="d-flex flex-row justify-content-between notification-message-container">

                    <div class='order-1 box-message'>
                        <div class="box-message-title-container">
                            ${this.messageTitle(classname)}
                        </div>
                        <p class="caption-lg box-message-message">${message}</p>
                    </div>

                    <span type="button" data-action="close" id="close-message-btn" class="order-2 box-button">                        
                        <img class="icon-lg" src="${
                            typeIcons.trashIcon
                        }" alt="Close" data-action="close" />                        
                    </span>
                </div>
            </li>
        `;
    },

    messageTitle(classname) {
        const icons = this.iconsStructure();
        const typeIcons = icons[classname] || icons.danger;

        return `
            <img class="icon-md" src='${typeIcons.errorIcon}' alt='${classname} Icon' />
            <p class="body-1 box-message-title">${typeIcons.title}</p>
        `;
    },
    removeResponseMessages(time = 5000) {
        setTimeout(function () {
            //Remove active class
            ["d-flex", "success", "danger", "warning"].forEach((value) => {
                if (
                    document
                        .querySelector(".responsebasemessage")
                        .classList.contains(value)
                ) {
                    document
                        .querySelector(".responsebasemessage")
                        .classList.remove(value);
                }
            });

            //Remove children elements
            let ul = document.querySelector(".responsebasemessage").children;

            [...ul[0].children].forEach((valli) => {
                //Remove Elements
                valli.remove();
            });
        }, time);
    },
    closeBox(element) {
        if (
            element.hasAttribute("data-action") &&
            element.getAttribute("data-action") === "close"
        ) {
            this.removeResponseMessages(0);
        }
    },
    renderResponseMessages(
        parentElement,
        classname,
        message,
        activeclass,
        timeout = 10000
    ) {
        //Add active Class
        parentElement.classList.add(activeclass);
        parentElement.classList.add(classname);

        //Element for append
        let li = this.messageStructure(message, classname);

        //Append Element
        $(li).appendTo(parentElement.children);

        //Remove Message
        this.removeResponseMessages(timeout);
    },
};

export default responseMessage;
